import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';

import { EboObject } from '../../base-classes/ebo-object';
import { State } from '../../places/state/state';
import { CdlClassType } from './cdl-class-type.enum';
import { CDLEndorsements, CDLEndorsementsAbbrMapping, CDLEndorsementsMapping } from './cdl-endorsements';

export class CommercialDriverLicense extends EboObject {
  name: string;
  number: string;
  classType: CdlClassType;
  stateID: string;
  state: State;
  issued: Dayjs;
  expiration: Dayjs;
  endorsements: CDLEndorsements;

  constructor(jsonData?: Partial<CommercialDriverLicense>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.state) {
        this.state = new State(jsonData.state);
      }
      if (jsonData.issued) this.issued = SDate.newUtc(jsonData.issued);
      if (jsonData.expiration) this.expiration = SDate.newUtc(jsonData.expiration);
    }
    this.classType ??= CdlClassType.Unknown;
  }

  ToString(): string {
    let response = '';
    if (this.state) {
      response += this.state.abbreviation;
    }
    if (response !== '' && this.number) {
      response += ' #';
    }
    if (this.number) {
      response += this.number;
    }
    return response;
  }

  toShortString(): string {
    return this.ToString();
  }
  ToEndorsementString(): string {
    const response = new Array<string>();
    if (this.HasFlag(CDLEndorsements.DTTrailers)) {
      response.push(CDLEndorsementsMapping[CDLEndorsements.DTTrailers]);
    }
    if (this.HasFlag(CDLEndorsements.Passenger)) {
      response.push(CDLEndorsementsMapping[CDLEndorsements.Passenger]);
    }
    if (this.HasFlag(CDLEndorsements.Tank)) {
      response.push(CDLEndorsementsMapping[CDLEndorsements.Tank]);
    }
    if (this.HasFlag(CDLEndorsements.HazMat)) {
      response.push(CDLEndorsementsMapping[CDLEndorsements.HazMat]);
    }
    if (this.HasFlag(CDLEndorsements.TankAndHazMat)) {
      response.push(CDLEndorsementsMapping[CDLEndorsements.TankAndHazMat]);
    }
    if (this.HasFlag(CDLEndorsements.SchoolBus)) {
      response.push(CDLEndorsementsMapping[CDLEndorsements.SchoolBus]);
    }
    if (response.length === 0) {
      response.push(CDLEndorsementsMapping[CDLEndorsements.None]);
    }
    return response.join(',');
  }

  ToEndorsementAbbrString(): string {
    const response = new Array<string>();
    if (this.HasFlag(CDLEndorsements.DTTrailers)) {
      response.push(CDLEndorsementsAbbrMapping[CDLEndorsements.DTTrailers]);
    }
    if (this.HasFlag(CDLEndorsements.Passenger)) {
      response.push(CDLEndorsementsAbbrMapping[CDLEndorsements.Passenger]);
    }
    if (this.HasFlag(CDLEndorsements.Tank)) {
      response.push(CDLEndorsementsAbbrMapping[CDLEndorsements.Tank]);
    }
    if (this.HasFlag(CDLEndorsements.HazMat)) {
      response.push(CDLEndorsementsAbbrMapping[CDLEndorsements.HazMat]);
    }
    if (this.HasFlag(CDLEndorsements.TankAndHazMat)) {
      response.push(CDLEndorsementsAbbrMapping[CDLEndorsements.TankAndHazMat]);
    }
    if (this.HasFlag(CDLEndorsements.SchoolBus)) {
      response.push(CDLEndorsementsAbbrMapping[CDLEndorsements.SchoolBus]);
    }
    if (response.length === 0) {
      response.push(CDLEndorsementsAbbrMapping[CDLEndorsements.None]);
    }
    return response.join(',');
  }
  /*
    static test(){
        let test2 = new CommercialDriverLicense();
        test2.expiration.toLocaleDateString()
    }
    */

  isValid(): boolean {
    return this.number && this.stateID && this.expiration ? true : false;
  }

  HasFlag(flag: CDLEndorsements): boolean {
    // eslint-disable-next-line no-bitwise
    return flag === (this.endorsements & flag);
  }

  SetFlag(flag: CDLEndorsements, value: boolean) {
    if (value) {
      // eslint-disable-next-line no-bitwise
      this.endorsements |= flag;
    } else {
      // eslint-disable-next-line no-bitwise
      this.endorsements &= ~flag;
    }
  }
}
